module.exports = __webpack_public_path__ + "img/icon_warning_square.739edd17.svg";